<template>
  <div class="roster-page mb-5">
      <div class="row mb-4 mt-2">
        <div class="col-12 col-md-4">
          <h4 v-if="Number(status) === 0">Pending Mobility Requests</h4>
          <h4 v-else-if="Number(status) === 1">Approved Mobility Requests</h4>
          <h4 v-else-if="Number(status) === 2">Declined Mobility Requests</h4>
        </div>

        <div class="col-12 col-md-4 mb-2 mb-md-0">
          <b-input-group class="my-0">
            <b-input-group-prepend is-text>
              <b-icon icon="search"></b-icon>
            </b-input-group-prepend>

            <b-form-input
              type="search"
              placeholder="Search..."
              v-model="search"
              @input="setFirstPage"
            ></b-form-input>
          </b-input-group>
        </div>

        <div class="col-12 col-md-4 d-flex justify-content-md-end align-items-center">
          <template v-if="Number(status) === 0">
            <b-button
              @click="confirmUpdateAttendanceRequest(selected, 1)"
              :disabled="selected.length === 0"
            >
              <b-icon icon="check" class="mr-1"></b-icon> Approve Selected
            </b-button>

            <b-button
              class="ml-2"
              @click="confirmUpdateAttendanceRequest(selected, 2)"
              :disabled="selected.length === 0"
            >
              <b-icon icon="x" class="mr-1"></b-icon> Decline Selected
            </b-button>
          </template>
        </div>
      </div>

      <div class="employee-table-wrapper table-sticky-height mt-3">
        <table class="employee-list-table table-overflow ess-custom-table document-table tax-documents table-list fund_list_table">
          <thead>
            <tr class="table-head">
              <td v-if="Number(status) === 0" class="checkbox-col px-3">
                <input
                  type="checkbox"
                  class=""
                  :checked="isAllSelected()"
                  @change="toggleSelectAll($event.target.checked)"
                />
                <label for=""></label>
              </td>
              <th>Employee</th>
              <th>Department</th>
              <th>Job Position</th>
              <th>Time</th>
              <th>Date</th>
              <th>Mobility Type</th>
              <th>Note</th>
              <th class="text-right" v-if="Number(status) === 0">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(application, i) in paginatedData"
              :key="application.application_id || i"
              class="table-row hover-bg"
            >
              <td v-if="Number(status) === 0" class="checkbox-col px-3">
                <input
                  type="checkbox"
                  class=""
                  v-model="selected"
                  :value="application.application_id"
                />
                <label for=""></label>
              </td>

              <td>
                <div class="d-flex align-items-center">
                  <div class="img-holder">
                    <img
                      :src="$api_url + '/avatar/' + application.company_id + '/' + application.employee_pic"
                      class="img-fluid img-thumbnail employee-avatar mr-2"
                    />
                  </div>

                  <div>
                    <div class="font-weight-bold">
                      {{ application.name || '' }}
                    </div>
                  </div>
                </div>
              </td>

              <td>{{ application.department || '' }}</td>
              <td>{{ application.jobposition || '' }}</td>
              <td>{{ application.time || '' }}</td>
              <td>{{ application.date || '' }}</td>
              <td>{{ application.location || '' }}</td>
              <td>{{ application.note || '' }}</td>

              <td v-if="Number(status) === 0" class="position-relative text-right">
                <a
                  :id="'actionDropdown-' + i"
                  class="dropdown-toggle clearfix action-dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <b-icon icon="three-dots-vertical"></b-icon>
                </a>

                <div
                  class="dropdown-menu action-dropdown-menu px-0"
                  :aria-labelledby="'actionDropdown-' + i"
                >
                  <b-button-toolbar>
                    <b-button-group class="mr-0">
                      <b-button
                        class="rounded edit-btn"
                        title="Approve"
                        @click="confirmUpdateAttendanceRequest([application.application_id], 1)"
                      >
                        <b-icon icon="check" class="mr-2" aria-hidden="true"></b-icon>
                        Approve
                      </b-button>

                      <b-button
                        class="rounded edit-btn"
                        title="Reject"
                        @click="confirmUpdateAttendanceRequest([application.application_id], 2)"
                      >
                        <b-icon icon="x" class="mr-2" aria-hidden="true"></b-icon>
                        Reject
                      </b-button>
                    </b-button-group>
                  </b-button-toolbar>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="row py-2 no-margin d-flex justify-content-between"
        v-if="paginatedData.length > 0"
      >
        <ul class="pagination b-pagination float-left mb-0 mt-1">
          <li class="page-item disabled m-2">View</li>
          <li class="page-item disabled">
            <b-form-select
              v-model="temp_length"
              :options="length_options"
              @change="setFirstPage"
            ></b-form-select>
          </li>
          <li class="page-item disabled m-2">
            per page. Total {{ pagination.total }} records found.
          </li>
        </ul>

        <b-pagination-nav
          v-model="pagination.currentPage"
          :number-of-pages="pagination.pages"
          prev-text="Previous"
          next-text="Next"
          base-url="#"
          first-number
          last-number
        ></b-pagination-nav>
      </div>

      <div
        class="row py-2 no-margin justify-content-center"
        v-if="paginatedData.length === 0"
      >
        No Mobility Requests.
      </div>
    </div>
</template>

<script>
export default {
  props: ['status', 'roster'],

  data() {
    return {
      attendance_requests: [],
      selected: [],
      search: '',

      temp_length: 10,
      length_options: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' }
      ],

      pagination: {
        currentPage: 1,
        total: 0,
        nextPage: null,
        prevPage: null,
        from: 0,
        to: 0,
        pages: 1
      }
    };
  },

  computed: {
    filteredData() {
      const searchText = String(this.search || '').toLowerCase().trim();

      if (!searchText) {
        return this.attendance_requests;
      }

      const searchableColumns = [
        'name',
        'department',
        'jobposition',
        'time',
        'date',
        'location',
        'note'
      ];

      return this.attendance_requests.filter(row => {
        const rowData = {
          name: row.name,
          department: row.department,
          jobposition: row.jobposition,
          time: row.time,
          date: row.date,
          location: row.location,
          note: row.note
        };

        return searchableColumns.some(column => {
          return String(rowData[column] || '')
            .toLowerCase()
            .includes(searchText);
        });
      });
    },

    paginatedData() {
      return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
    }
  },

  methods: {
    changeLoading(status) {
        this.$emit('changeLoading', status);
    },
    setFirstPage() {
      this.pagination.currentPage = 1;
    },

    paginate(data, length, page) {
      const start = (page - 1) * length;
      const end = start + length;

      this.pagination.total = data.length;
      this.pagination.pages = Math.max(Math.ceil(data.length / length), 1);
      this.pagination.from = data.length ? start + 1 : 0;
      this.pagination.to = end > data.length ? data.length : end;
      this.pagination.prevPage = page > 1 ? page - 1 : null;
      this.pagination.nextPage = page < this.pagination.pages ? page + 1 : null;

      return data.slice(start, end);
    },

    isAllSelected() {
      if (!this.paginatedData.length) {
        return false;
      }

      const ids = this.paginatedData.map(item => item.application_id);

      return ids.every(id => this.selected.includes(id));
    },

    toggleSelectAll(checked) {
      if (checked) {
        this.selected = this.paginatedData.map(row => row.application_id);
      } else {
        this.selected = [];
      }
    },

    getAttendanceRequests() {
        this.changeLoading(true);

        axios.get(this.$api_url + '/leave-attendance/approver/mobility-queue', {
            params: {
              status: this.status
            }
        }).then(response => {
            this.attendance_requests = Array.isArray(response.data) ? response.data : [];
            this.selected = [];
        }).catch(error => {
            this.serverError(error);
        }).finally(() => {
            this.changeLoading(false);
        });
    },

    confirmUpdateAttendanceRequest(ids, status) {
      const actionText = status === 1 ? 'approve' : 'decline';
      this.$bvModal.msgBoxConfirm(
        `Are you sure you want to ${actionText} the selected requests?`,
        {
          title: 'Confirm Action',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          centered: true
        }
      ).then(confirmed => {
        if (!confirmed) return;
        this.updateAttendanceRequest(ids, status);
      });
    },

    updateAttendanceRequest(ids, status) {
        if (!ids || ids.length === 0) {
            this.$bvToast.toast('No Mobility Requests Selected.', {
              title: 'Failed',
              variant: 'danger',
              solid: true
            });
            return;
        }

        this.changeLoading(true);

        axios.post(this.$api_url + '/leave-attendance/approver/mobility-queue/update', {
          ids: ids,
          status: status
        })
        .then(response => {
          this.$bvToast.toast(response.data.message || 'Updated successfully!', {
              title: 'Success',
              variant: 'success',
              solid: true
          });

          this.selected = [];
          this.changeLoading(false);

          this.$nextTick(() => {
              this.$emit('refreshLists');
          });
        })
        .catch(error => {
          this.serverError(error);
          this.changeLoading(false);
        });
    }
  },

  created() {
    this.getAttendanceRequests();
  }
};
</script>
